import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.scss'],
})
export class SearchListComponent {
  @Input() filteredPlantillas;
  @Output() plantillaSeleccionada = new EventEmitter<string>();

  constructor(private popoverCtrl: PopoverController) { }

  selectPlantilla(nombre: string) {
    this.popoverCtrl.dismiss({ nombre });
  }
}
